export default "__VITE_ASSET__68f9accc__"